document.addEventListener('DOMContentLoaded', function () {

	let data_transfer = {
		"jewelry_form" : new DataTransfer(),
		"timepiece_form" : new DataTransfer() 
	};

	function scrollIntoViewWithOffset(element, offset) {

		if (! element ) {
			return;
		}
	
		window.scrollTo({
			behavior: 'smooth',
			top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
		});

	}

	function format_bytes(bytes) {
		if (bytes < 1024) {
			return bytes + ' Bytes';
		} else if (bytes >= 1024 && bytes < 1048576) {
			return Math.ceil(bytes / 1024) + ' KB';
		} else {
			return Math.ceil(bytes / 1048576) + ' MB';
		}
	}

	function handle_files(the_form, files) {

		const file_array = Array.from(files);

		const data_transfer_key = the_form.getAttribute('id');
		const file_preview = the_form.querySelector('.file_preview');
		const file_input = the_form.querySelector('.file_upload_wrapper [type="file"]');

		if ( file_array.length + data_transfer[ data_transfer_key ].files.length > 3 ) {
			alert( 'You can upload up to 3 files.' );
			return false;
		}

		file_array.forEach(file => {

			if ( validate_file(file) ) {

				// Add the file to the DataTransfer object
				data_transfer[ data_transfer_key ].items.add(file);

				// Show the preview
				const file_item_preview = document.createElement('div');
				file_item_preview.classList.add('file-item-preview');

				const img = document.createElement('img');
				img.src = URL.createObjectURL(file);
				img.alt = file.name;

				const name = document.createElement('span');
				name.innerHTML = '<span>' + file.name + '</span> (' + format_bytes(file.size) + ')';

				const remove_button = document.createElement('button');
				remove_button.type = 'button';
				remove_button.innerHTML = '&times;&nbsp; Remove';
				remove_button.addEventListener('click', () => {
					file_item_preview.remove();
					remove_file(the_form, file);
				});

				file_item_preview.appendChild(img);
				file_item_preview.appendChild(name);
				file_item_preview.appendChild(remove_button);
				file_preview.appendChild(file_item_preview);
			}
		});

		// Update the file input with the new file list
		file_input.files = data_transfer[ data_transfer_key ].files;

	}

	function remove_file(the_form, file) {

		const data_transfer_key = the_form.getAttribute('id');
		const file_input = the_form.querySelector('.file_upload_wrapper [type="file"]');

		// Remove the file from the DataTransfer object
		for (let i = 0; i < data_transfer[ data_transfer_key ].items.length; i++) {
			if (data_transfer[ data_transfer_key ].items[i].getAsFile() === file) {
				data_transfer[ data_transfer_key ].items.remove(i);
				break;
			}
		}

		// Update the file input with the remaining files
		file_input.files = data_transfer[ data_transfer_key ].files;
	}

	function validate_file(file) {
		const valid_types = ['image/jpeg', 'image/png'];
		if (!valid_types.includes(file.type)) {
			alert('Only PNG and JPEG images are allowed.');
			return false;
		}

		if ( file.size > 10485760 ) {
			alert('Maximum of 10MB per file.');
			return false;
		}

		return true;
	}

	function validateFormFields( form ) {

		const required_fields = form.querySelectorAll('.form-field-wrap .required');
		if (!required_fields) {
			return false;
		}
	
		let errors = [];
	
		required_fields.forEach((el) => {
	
			if (!el.value) {
				errors.push(el.getAttribute('id'));
				el.classList.add('field-error');
			} else {
				el.classList.remove('field-error');
			}
	
		});

		form.querySelectorAll('.checkbox-required').forEach( ( container ) => {

			let checked = 0;
			const checkboxes = container.querySelectorAll('[type="radio"]');

			checkboxes.forEach( (el) => {
				if ( el.checked ) {
					checked++;
				}
			});
			
			if ( ! checked ) {
				checkboxes.forEach( (el) => {
					errors.push(el.getAttribute('name'));
					el.classList.add('field-error');
				});
			} else {
				checkboxes.forEach( (el) => {
					el.classList.remove('field-error');
				});
			}

		});

		const file_upload_wrapper = form.querySelector('.file_upload_wrapper');
		const file_input = file_upload_wrapper.querySelector('[type="file"]');

		if ( ! file_input.files.length ) {
			errors.push( file_input.getAttribute('name') );
			file_upload_wrapper.classList.add('field-error');
		} else {
			file_upload_wrapper.classList.remove('field-error');
		}
	
		if (required_fields.length) {
			required_fields[0].focus();
		}
	
		return errors;
	
	}

	document.querySelectorAll('.section-form-bst form').forEach((the_form) => {

		const file_preview = the_form.querySelector('.file_preview');
		const file_upload_wrapper = the_form.querySelector('.file_upload_wrapper');
		const file_input = file_upload_wrapper.querySelector('[type="file"]');
				
		// Click to open file selector
		file_upload_wrapper.addEventListener('click', () => {
			file_input.click();
		});

		// Drag and Drop functionality
		file_upload_wrapper.addEventListener('dragover', (e) => {
			e.preventDefault();
			file_upload_wrapper.classList.add('dragging');
		});

		file_upload_wrapper.addEventListener('dragleave', () => {
			file_upload_wrapper.classList.remove('dragging');
		});

		file_upload_wrapper.addEventListener('drop', (e) => {
			e.preventDefault();
			file_upload_wrapper.classList.remove('dragging');
			handle_files(the_form, e.dataTransfer.files);
		});

		// File input change event
		file_input.addEventListener('change', (e) => {
			handle_files(the_form, e.target.files);
		});

		the_form.addEventListener('submit', (event) => {
			event.preventDefault();
				
			const errors = validateFormFields( the_form );
			if (errors.length) {
				alert('Please check all required fields marked with *');
				return false;
			}
	
			the_form.classList.add('loading');
	
			the_form.querySelectorAll('input, button, select, textarea').forEach((el) => {
				el.readOnly = true;
			});
		
			const submit_button = the_form.querySelector('[type="submit"]');
	
			const form_success = the_form.querySelector('.form_success');
			const form_errors = the_form.querySelector('.form_errors');
		
			submit_button.setAttribute('disabled', 'disabled');
			submit_button.innerHTML = 'Submitting...';
		
			var formData = new FormData(the_form);
		
			fetch( the_form.getAttribute('action'), {
					method: 'POST',
					body:formData
				})
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok: ' + response.statusText);
					}
					return response.json(); // Parse JSON response
				})
				.then(data => {
					form_errors.style.display = 'none';
		
					form_success.style.display = 'block';
		
					the_form.reset();
				})
				.catch(error => {
					form_success.style.display = 'none';
		
					form_errors.innerHTML = error.message;
					form_errors.style.display = 'block';
				})
				.finally(() => {
					scrollIntoViewWithOffset(the_form, 200);
	
					the_form.querySelectorAll('input, button, select, textarea').forEach((el) => {
						el.readOnly = false;
					});
	
					the_form.classList.remove('loading');
					submit_button.removeAttribute('disabled');
					submit_button.innerHTML = 'SUBMIT YOUR REQUEST';

				});
		
		});

	});

});